export const bottomNotification = (state) => state.notification.bottomMsg;
